import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import React, { useState } from 'react';

import EditNameModal from './Modal/EditNameModal';
import EditPasswordModal from './Modal/EditPasswordModal';
import Icon from './Icon';
import { contentfulPropTypes } from '../propTypes';
import currentUserPropTypes from '../propTypes/currentUserPropTypes';
import { primary } from '../theme/colors';
import styled from 'styled-components';

const EmailCta = styled.p`
  color: #000;
  font-size: 12px;
  margin-bottom: 0;
`;

const EditProfileForm = ({ contentful, currentUser, setUser }) => {
  const [showEditNameForm, setShowEditNameForm] = useState(false);
  const [showEditPasswordForm, setShowEditPasswordForm] = useState(false);

  return (
    <>
      <EditNameModal
        show={showEditNameForm}
        onHide={() => setShowEditNameForm(false)}
        currentUser={currentUser}
        setUser={setUser}
      />
      <EditPasswordModal
        show={showEditPasswordForm}
        onHide={() => setShowEditPasswordForm(false)}
      />
      <div id="account-overview">
        <Form>
          <Container>
            <Row>
              <Col className="mb-3" lg={8}>
                <Icon colour={primary} icon="overview" className="mb-2" />
                <h2>{contentful?.title}</h2>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col lg={8}>
                <Form.Group controlId="email" className="mb-2">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    value={currentUser?.attributes?.email}
                    disabled
                  />
                </Form.Group>
                <EmailCta>
                  You can&apos;t change your email address.{' '}
                  <a href="https://kb.loop.homes/why-cant-i-change-my-email-address-after-ive-signed-up-to-loop">
                    Why not?
                  </a>
                </EmailCta>
              </Col>
            </Row>
            <Row className="align-items-end mb-4">
              <Col lg={3} md={5} className="mb-4 mb-md-0">
                <Form.Group controlId="given_name" className="mb-0">
                  <Form.Label>First name</Form.Label>
                  <Form.Control
                    type="text"
                    value={currentUser?.attributes?.given_name}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col lg={3} md={5} className="mb-4 mb-md-0">
                <Form.Group controlId="family_name" className="mb-0">
                  <Form.Label>Last name</Form.Label>
                  <Form.Control
                    type="text"
                    value={currentUser?.attributes?.family_name}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col lg={2} md={2}>
                <Button
                  type="button"
                  variant="primary"
                  className="my-0 w-100"
                  onClick={() => setShowEditNameForm(true)}>
                  Edit
                </Button>
              </Col>
            </Row>
            <Row className="align-items-end mb-0">
              <Col lg={6} md={6} className="mb-4 mb-md-0">
                <Form.Group controlId="password" className="mb-0">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" value="**********" disabled />
                </Form.Group>
              </Col>
              <Col lg={2} md={2}>
                <Button
                  type="button"
                  variant="primary"
                  className="my-0 w-100"
                  onClick={() => setShowEditPasswordForm(true)}>
                  Edit
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </>
  );
};

EditProfileForm.propTypes = {
  ...contentfulPropTypes,
  ...currentUserPropTypes,
};

export default EditProfileForm;
